export const texts = {
  loading: 'Загрузка...',
  addTenant: 'Добавить жильца',
  editTenant: 'Изменить данные жильца',
  addPersonalAccount: 'Добавить лицевой счет',
  addAccount: 'Добавить счет',
  addInfo: 'Добавить информацию',
  addFlatsGrid: 'Добавить шахматку',
  chooseFlatsGridCreationMethod: 'Выберите способ добавления шахматки',
  addDocument: 'Добавить документ',
  formFlatsGrid: 'Сформировать шахматку',
  flatsGridPreviewCancelCreateConfiramtion:
    'Вы уверены, что хотите отменить создание шахматки?',
  flatsGridPreviewCancelEditConfiramtion:
    'Вы уверены, что хотите отменить редактирование шахматки?',
  managementCompany: 'Управляющая компания',
  editComment: 'Изменить комментарий',
  addComment: 'Добавить комментарий',
  addNewHouse: 'Добавить новый дом',
  add: 'Добавить',
  cancel: 'Отменить',
  create: 'Создать',
  edit: 'Изменить',
  delete: 'Удалить',
  comment: 'Комментарий',
  homeBalance: 'Баланс по дому',
  homeDocuments: 'Документы по дому',
  flatDocuments: 'Документы по помещению',
  flatAccountsPersone: 'Лицевые счета',
  flatRoomStage: 'Жизненный цикл помещения',
  flatRoomDdy: 'Характеристика помещения',
  rebalancing: 'Изменение баланса',
  balance: 'Баланс',
  searchByAddress: 'Поиск по адресу',
  searchByFullName: 'Поиск по ФИО',
  searchByAccountNumber: 'Поиск по номеру счета',
  seacrhByFlatNumber:
    'Поиск по номеру помещения или по номеру помещения по ДДУ',
  draggableAddDocsDescription:
    'Кликните или перетащите документы в эту область',
  deleteDocumentQuestion: 'Удалить документ?',
  yes: 'Да',
  no: 'Нет',
  tenant: 'Житель',
  owner: 'Собственник',
  downloadReports: 'Выгрузить отчеты',
  houseStage: 'Статус дома',
  addressStage: 'Статус квартиры',
  premisesStage: 'Стадия помещения',
  acceptanceStage: 'Статус приемки',
  stepStage: 'Этап',
  saleStage: 'Продажа',
  searchByNamePhoneEmail: 'Поиск по ФИО, никнейму, номеру телефона или email',
  debt: 'Долг',
  activeRequest: 'Активная заявка',
  immediateRequest: 'Аварийная заявка',
};
